<template>
  <div class="breadcrumb">
    <span>您的位置：</span>
    <router-link to="/">首页</router-link> /
    <template v-for="(item, index) in paths">
      <span :key="index" :class="{ current: index === paths.length - 1 }">
        {{ item }}
      </span>
      <span :key="'slash' + index" v-if="index < paths.length - 1"> / </span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageBreadcrumb',
  props: {
    paths: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.breadcrumb {
  padding: 15px 0;
  color: #666;
}

.breadcrumb a {
  color: #666;
  text-decoration: none;
}

.breadcrumb .current {
  color: #000000;
  font-weight: bold;
}

.breadcrumb a:hover {
  color: #000000;
}
</style> 